import ServiceLocator from "../../../global/service-locator";
import Api from "../../../lib/api";

export default class B2bDocsModal {
    constructor() {
        this.$root = document.getElementById('b2b-docs');
        if (!this.$root) return;

        this.$trigger = document.querySelector('[data-modal-trigger="b2b-docs"]');
        this.$searchField = this.$root.querySelector('.b2b-search-control-field');
        this.$searchInput = this.$root.querySelector('.b2b-search-control-input');
        this.$searchButton = this.$root.querySelector('.b2b-search-control-button');
        this.$searchPanel = this.$root.querySelector('.b2b-search-panel');
        this.$searchPanelBody = this.$searchPanel.querySelector('.b2b-search-panel-body');

        this.sl = ServiceLocator.instance;
        this.value = '';
        this.submitted = false;
        this.valid = false;
        this.minSymbols = 8;
        this.maxSymbols = 10;

        this.init();
    }

    init() {
        this.sl.modalService.register('b2b-docs', this.$trigger, {
            hash: 'docs'
        });
        this.addEventListeners();
    }

    addEventListeners() {
        this.$searchField.addEventListener('click', () => {
            this.$searchInput.focus();
        });
        this.$searchInput.addEventListener('focus', () => {
            this.$searchField.classList.add('-active');
        });
        this.$searchInput.addEventListener('blur', () => {
            if (this.$searchInput.value) return;
            this.$searchField.classList.remove('-active');
        });
        this.$searchInput.addEventListener('input', (e) => {
            this.submitted = false;

            if (e.target.value.length > this.maxSymbols || !/^\d*$/.test(e.target.value)) {
                this.$searchInput.value = this.value;
                return;
            }

            this.$searchButton.disabled = e.target.value.length < this.minSymbols;
            this.value = e.target.value;
        });
        this.$searchButton.addEventListener('click', () => {
            if (!this.$searchInput.value ||
                this.submitted ||
                this.value.length < this.minSymbols ||
                this.value.length > this.maxSymbols) return;

            this.submitted = true;
            this.$searchButton.disabled = true;
            this.setPanelState('loading');
            this.fetchData(this.value)
                .then(res => {
                    if (!res.success || !res.response || !res.response.length) {
                        this.setPanelState('empty');
                        return;
                    }
                    this.setPanelState('loaded');
                    this.renderData(res.response);
                })
                .catch((error) => {
                    if (error.status === 404) {
                        this.setPanelState('empty');
                        return;
                    }

                    this.setPanelState('error');
                });
        });
    }

    fetchData(id) {
        return Api.get(Api.ttApiUrl + '/vchasno_docs/' + id);
    }

    renderData(data) {
        this.$searchPanelBody.innerHTML = '';
        data.forEach(dataItem => {
            this.$searchPanelBody.insertAdjacentHTML('beforeend',
                this.getDocLinkTemplate({ url: dataItem.url_vchasno, title: dataItem.title, date: dataItem.date }));
        });
    }

    setPanelState(state) {
        this.$searchPanel.classList.remove('-loading', '-loaded', '-error', '-empty');
        if (state === 'initial') return;
        this.$searchPanel.classList.add(`-${state}`);
    }

    getDocLinkTemplate({ url, title, date }) {
        return `
            <div class="b2b-doc-link">
                <a href="${url}" class="block-anchor" target="_blank" rel="nofollow">${title}</a>
                <svg xmlns="http://www.w3.org/2000/svg"
                     class="b2b-doc-link_icon"
                     width="32"
                     height="32"
                     viewBox="0 0 32 32"
                     fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 16C0 7.16338 7.16338 0 15.9999 0C24.8367 0 32 7.16338 32 16C32 24.8366 24.8367 32 15.9999 32C7.16338 32 0 24.8366 0 16Z" fill="#FFF200"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.0402 24.8889C11.1609 24.8889 7.11108 20.9017 7.11108 16C7.11108 11.0988 11.2684 7.11108 15.8803 7.11108V9.68452C12.8061 9.68452 9.6729 12.5177 9.6729 16C9.6729 19.4823 12.5335 22.3154 16.0002 22.3154C19.4664 22.3154 22.307 19.4823 22.307 16C22.307 14.928 22.0473 13.8832 21.5405 12.9583C19.8323 14.7766 17.2396 17.6448 17.2069 17.6803L16.3567 18.6221L12.5935 15.2563L14.2971 13.3345L16.1704 15.0093C17.4477 13.6063 19.8026 11.0339 20.7925 10.0406L21.7526 9.07661L22.655 10.0962C24.0957 11.7236 24.8889 13.8203 24.8889 16C24.8889 20.9017 20.9194 24.8889 16.0402 24.8889Z" fill="#333333"/>
                </svg>
                <span class="b2b-doc-link-title">${title}${date ? ' від ' + date : ''}</span>
                <span class="b2b-doc-link-subtitle">${craft.localization['form.b2b.edrpou.search.watchInVchasno']}</span>
            </div>
        `;
    }
}